<template>
  <div class="w-full flex-1-0-auto header-height-top-space">
    <div class="w-full pb-4 xl:pb-6">
      <div class="mb-8 md:px-6 lg:px-8 xl:px-20 xl:mb-12">
        <div class="container">
          <StepNavigation
            :step1="tr('pages.sales.steps.step1')"
            :step2="tr('pages.sales.steps.step2')"
            :step3="tr('pages.sales.steps.step3')"
            :active-step="1"
          />
        </div>
      </div>

      <div id="main-content" class="w-full viewport-gutter">
        <div class="container">
          <div class="space-y-3 text-sm xl:text-lg font-family-portado xl:space-y-6">
            <h1 class="text-3xl font-bold leading-none xl:text-4xl">
              {{ tr('pages.sales.buy.title') }}
            </h1>
            <p class="leading-relaxed">
              {{ tr('pages.sales.buy.description') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full pt-3 pb-16 md:pt-12 md:pb-0">
      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="flex flex-col-reverse justify-between w-full xl:flex-row">
            <div class="w-full mb-12 max-w-104 md:flex md:max-w-none md:mb-8 xl:max-w-104 xl:block xl:pr-6 xl:mr-6 xl:mb-0">
              <div class="mt-12 text-sm xl:pl-10 xl:text-lg xl:w-full">
                <ul class="space-y-6 list-checkmark-2 text-au_gray-700">
                  <li v-html="tr('pages.sales.buy.cards.point1')" />
                  <li v-html="tr('pages.sales.buy.cards.point3')" />
                  <li v-html="tr('pages.sales.buy.cards.point4')" />
                </ul>

              </div>
            </div>
            <VoucherAmountSelector class="w-full p-6 bg-au_gray-100 xl:max-w-183" />
          </div>
        </div>
      </div>

      <div class="container mb-12 xl:mb-32 md:mt-20 xl:mt-40">
        <HowItWorks />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import HowItWorks from '~brand-components/austrian/sale/how-it-works.vue'
import VoucherAmountSelector from '~brand-components/austrian/sale/voucher-amount-selector.vue'
import StepNavigation from '~brand-components/austrian/navigation/step-navigation.vue'
export default Vue.extend({
  components: {
    HowItWorks,
    VoucherAmountSelector,
    StepNavigation,
  },
})
</script>
